module.exports = __webpack_public_path__ + "img/webflow.3d74b5f3.jpg";